var ready = function (fn) {
    // Sanity check
    if (typeof fn !=='function') return;
    // If document is already loaded, run method
    if (document.readyState==='interactive'||document.readyState==='complete') {
        return fn();
    }
    // Otherwise, wait until document is loaded
    document.addEventListener('DOMContentLoaded', fn,false);
};


ready(function() {

    function waveOne() {
      var canvas = document.getElementById("canvas-white-bg");

      if (canvas) {
        var context = canvas.getContext("2d");
        var resolution = window.devicePixelRatio || 1;
  
        var waves = [];
        var resized = false;
  
        var vw, vh;
        var frequency = 2;
        var amplitude = 45;
        var secondAmplitude = 10;
        
        resizeCanvas();
  
        var waveHeight = vh * 0.35;
  
        if (vw >= 768 && vw < 992) {
            vh = 60;
          } else if (vw >= 1200) {
            vh = 180;
            frequency = 2.5;
            amplitude = 120;
            secondAmplitude = 80;
            waveHeight = vh * 0.5;
          } else {
            vh = 85;
          }
  
        var wave1 = createWave(context, {
          amplitude: amplitude,
          duration: 5.75,
          fillStyle: "rgba(255,255,255,1)",
          frequency: frequency,
          width: vw,
          height: vh,
          segments: 100,
          waveHeight:  waveHeight
        });
        
        waves.push(wave1);
  
        gsap.to(waves, 10, {
          waveHeight: vh / 1.5,
          ease: Sine.easeInOut,
          repeat: -1,
          repeatDelay: 1,
          yoyo: true
        });
  
        gsap.to(wave1, 6, {
          amplitude: secondAmplitude,
          ease: Sine.easeInOut,
          repeat: -1,
          yoyo: true
        });
  
        window.addEventListener("resize", function() {
          resized = true;
        });
  
        gsap.ticker.add(update);
  
        function update() {
  
          var len = waves.length;
  
          if (resized) {
  
            resizeCanvas();
  
            for (var i = 0; i < len; i++) {
              waves[i].resize(vw, vh);
            }
  
            resized = false;
          }
  
          context.clearRect(0, 0, vw, vh);
          context.globalCompositeOperation = "soft-light";
  
          for (var i = 0; i < len; i++) {
            waves[i].draw();
          }
        }
  
        function createWave(context, options) {
  
          options = options || {};
  
          // API
          var wave = {
  
            // Properties
            amplitude: options.amplitude || 200,
            context: context,
            curviness: options.curviness || 0.75,
            duration: options.duration || 2,
            fillStyle: options.fillStyle || "rgba(255,255,255,1)",
            frequency: options.frequency || 4,
            height: options.height || 600,
            points: [],
            segments: options.segments || 100,
            tweens: [],
            waveHeight: options.waveHeight || 300,
            width: options.width || 800,
            x: options.x || 0,
            y: options.y || 0,
  
            // Methods
            init: init,
            resize: resize,
            draw: draw,
            kill: kill
          };
  
          init();
  
          function kill() {
  
            var tweens = wave.tweens;
            var len = tweens.length;
  
            for (var i = 0; i < len; i++) {
              tweens[i].kill();
            }
  
            tweens.length = 0;
            wave.points.length = 0;
          }
  
          function init() {
  
            kill();
  
            var segments = wave.segments;
            var interval = wave.width / segments;
  
            for (var i = 0; i <= segments; i++) {
  
              var norm = i / segments;
              var point = {
                x: wave.x + i * interval,
                y: 1
              };
  
              var tween = gsap.to(point, wave.duration, {
                y: -1,
                repeat: -1,
                yoyo: true,
                ease: Sine.easeInOut
              }).progress(norm * wave.frequency)
  
              wave.tweens.push(tween);
              wave.points.push(point);
            }
          }
  
          function draw() {
  
            var points = wave.points;
            var len = points.length;
  
            var startY = wave.waveHeight;
            var height = wave.amplitude / 2;
  
            context.beginPath();
            context.moveTo(points[0].x, startY + points[0].y * height);
  
            for (var i = 1; i < len; i++) {
  
              var point = points[i];
              context.lineTo(point.x, startY + point.y * height);
            }
  
            context.lineTo(wave.x + wave.width, wave.y + wave.height);
            context.lineTo(wave.x, wave.y + wave.height);
            context.closePath();
            context.fillStyle = wave.fillStyle;
            context.fill();
          }
  
          function resize(width, height) {
  
            wave.width = width;
            wave.height = height;
  
            var points = wave.points;
            var len = points.length;
            var interval = wave.width / wave.segments;
  
            for (var i = 0; i < len; i++) {
  
              var point = points[i];
              point.x = wave.x + i * interval;
            }
          }
  
          return wave;
        }
        
      }

      function resizeCanvas() {

        vw = document.documentElement.clientWidth;

        if (vw >= 768 && vw < 992) {
          vh = 60;
        } else if (vw >= 1200) {
          vh = 180;
        } else {
          vh = 85;
        }

        canvas.width  = vw * resolution;
        canvas.height = vh * resolution;

        canvas.style.width  = vw + "px";
        canvas.style.height = vh + "px";

        context.scale(resolution, resolution);
      }
    }

    function waveTwo() {
      var canvas = document.getElementById("canvas-dark-bg-top");
      var context = canvas.getContext("2d");
      var resolution = window.devicePixelRatio || 1;

      var waves = [];
      var resized = false;

      var vw, vh;
      resizeCanvas();

      var wave1 = createWave(context, {
        amplitude: 30,
        duration: 6,
        fillStyle: "rgba(0,0,0,1)",
        frequency: 2.25,
        width: vw,
        height: 200,
        segments: 100,
        waveHeight:  100 * 0.25
      });

      waves.push(wave1);

      gsap.to(waves, 10, {
        waveHeight: vh / 2,
        ease: Sine.easeInOut,
        repeat: -1,
        repeatDelay: 2,
        yoyo: true
      });

      gsap.to(wave1, 6, {
        amplitude: 10,
        ease: Sine.easeInOut,
        repeat: -1,
        yoyo: true
      });

      window.addEventListener("resize", function() {
        resized = true;
      });

      gsap.ticker.add(update);

      function update() {

        var len = waves.length;

        if (resized) {

          resizeCanvas();

          for (var i = 0; i < len; i++) {
            waves[i].resize(vw, vh);
          }

          resized = false;
        }

        context.clearRect(0, 0, vw, vh);
        context.globalCompositeOperation = "soft-light";

        for (var i = 0; i < len; i++) {
          waves[i].draw();
        }
      }

      function createWave(context, options) {

        options = options || {};

        // API
        var wave = {

          // Properties
          amplitude: options.amplitude || 200,
          context: context,
          curviness: options.curviness || 0.75,
          duration: options.duration || 2,
          fillStyle: options.fillStyle || "rgba(255,255,255,1)",
          frequency: options.frequency || 4,
          height: options.height || 600,
          points: [],
          segments: options.segments || 100,
          tweens: [],
          waveHeight: options.waveHeight || 300,
          width: options.width || 800,
          x: options.x || 0,
          y: options.y || 0,

          // Methods
          init: init,
          resize: resize,
          draw: draw,
          kill: kill
        };

        init();

        function kill() {

          var tweens = wave.tweens;
          var len = tweens.length;

          for (var i = 0; i < len; i++) {
            tweens[i].kill();
          }

          tweens.length = 0;
          wave.points.length = 0;
        }

        function init() {

          kill();

          var segments = wave.segments;
          var interval = wave.width / segments;

          for (var i = 0; i <= segments; i++) {

            var norm = i / segments;
            var point = {
              x: wave.x + i * interval,
              y: 1
            };

            var tween = gsap.to(point, wave.duration, {
              y: -1,
              repeat: -1,
              yoyo: true,
              ease: Sine.easeInOut
            }).progress(norm * wave.frequency)

            wave.tweens.push(tween);
            wave.points.push(point);
          }
        }

        function draw() {

          var points = wave.points;
          var len = points.length;

          var startY = wave.waveHeight;
          var height = wave.amplitude / 2;

          context.beginPath();
          context.moveTo(points[0].x, startY + points[0].y * height);

          for (var i = 1; i < len; i++) {

            var point = points[i];
            context.lineTo(point.x, startY + point.y * height);
          }

          context.lineTo(wave.x + wave.width, wave.y + wave.height);
          context.lineTo(wave.x, wave.y + wave.height);
          context.closePath();
          context.fillStyle = wave.fillStyle;
          context.fill();
        }

        function resize(width, height) {

          wave.width = width;
          wave.height = height;

          var points = wave.points;
          var len = points.length;
          var interval = wave.width / wave.segments;

          for (var i = 0; i < len; i++) {

            var point = points[i];
            point.x = wave.x + i * interval;
          }
        }

        return wave;
      }

      function resizeCanvas() {

        vw = document.documentElement.clientWidth;
        vh = 200;

        canvas.width  = vw * resolution;
        canvas.height = vh * resolution;

        canvas.style.width  = vw + "px";
        canvas.style.height = vh + "px";

        context.scale(resolution, resolution);
      }
    }

    function waveThree() {
      var canvas = document.getElementById("canvas-dark-bg-bottom");
      var context = canvas.getContext("2d");
      var resolution = window.devicePixelRatio || 1;

      var waves = [];
      var resized = false;

      var vw, vh;
      resizeCanvas();

      var wave1 = createWave(context, {
        amplitude: 50,
        duration: 2,
        fillStyle: "rgba(255,121,0,1)",
        frequency: 1.75,
        width: vw,
        height: 200,
        segments: 100,
        waveHeight:  100 * 0.25
      });
      
      waves.push(wave1);

      gsap.to(waves, 10, {
        waveHeight: vh / 2,
        ease: Sine.easeInOut,
        repeat: -1,
        repeatDelay: 2,
        yoyo: true
      });

      gsap.to(wave1, 6, {
        amplitude: 10,
        ease: Sine.easeInOut,
        repeat: -1,
        yoyo: true
      });

      window.addEventListener("resize", function() {
        resized = true;
      });

      gsap.ticker.add(update);

      function update() {

        var len = waves.length;

        if (resized) {

          resizeCanvas();

          for (var i = 0; i < len; i++) {
            waves[i].resize(vw, vh);
          }

          resized = false;
        }

        context.clearRect(0, 0, vw, vh);
        context.globalCompositeOperation = "soft-light";

        for (var i = 0; i < len; i++) {
          waves[i].draw();
        }
      }

      function createWave(context, options) {

        options = options || {};

        // API
        var wave = {

          // Properties
          amplitude: options.amplitude || 200,
          context: context,
          curviness: options.curviness || 0.75,
          duration: options.duration || 2,
          fillStyle: options.fillStyle || "rgba(255,255,255,1)",
          frequency: options.frequency || 4,
          height: options.height || 600,
          points: [],
          segments: options.segments || 100,
          tweens: [],
          waveHeight: options.waveHeight || 300,
          width: options.width || 800,
          x: options.x || 0,
          y: options.y || 0,

          // Methods
          init: init,
          resize: resize,
          draw: draw,
          kill: kill
        };

        init();

        function kill() {

          var tweens = wave.tweens;
          var len = tweens.length;

          for (var i = 0; i < len; i++) {
            tweens[i].kill();
          }

          tweens.length = 0;
          wave.points.length = 0;
        }

        function init() {

          kill();

          var segments = wave.segments;
          var interval = wave.width / segments;

          for (var i = 0; i <= segments; i++) {

            var norm = i / segments;
            var point = {
              x: wave.x + i * interval,
              y: 1
            };

            var tween = gsap.to(point, wave.duration, {
              y: -1,
              repeat: -1,
              yoyo: true,
              ease: Sine.easeInOut
            }).progress(norm * wave.frequency)

            wave.tweens.push(tween);
            wave.points.push(point);
          }
        }

        function draw() {

          var points = wave.points;
          var len = points.length;

          var startY = wave.waveHeight;
          var height = wave.amplitude / 2;

          context.beginPath();
          context.moveTo(points[0].x, startY + points[0].y * height);

          for (var i = 1; i < len; i++) {

            var point = points[i];
            context.lineTo(point.x, startY + point.y * height);
          }

          context.lineTo(wave.x + wave.width, wave.y + wave.height);
          context.lineTo(wave.x, wave.y + wave.height);
          context.closePath();
          context.fillStyle = wave.fillStyle;
          context.fill();
        }

        function resize(width, height) {

          wave.width = width;
          wave.height = height;

          var points = wave.points;
          var len = points.length;
          var interval = wave.width / wave.segments;

          for (var i = 0; i < len; i++) {

            var point = points[i];
            point.x = wave.x + i * interval;
          }
        }

        return wave;
      }

      function resizeCanvas() {

        vw = document.documentElement.clientWidth;
        vh = 200;

        canvas.width  = vw * resolution;
        canvas.height = vh * resolution;

        canvas.style.width  = vw + "px";
        canvas.style.height = vh + "px";

        context.scale(resolution, resolution);
      }
    }

    waveOne();
    // waveTwo();
    waveThree();

});